<template>
  <div>
  <div class="right-sidebar-panel-content animated fadeInRight" tabindex="5003" style="overflow: hidden; outline: none;"></div>
  <form @submit.prevent="login">
    <section class="main" :style="{background: `url(${back_img}) no-repeat center` }">
      <div class="bottom-grid">
        <div class="logo">
          <h1> <a href="#"> 信實數碼股份有限公司-營運平台 </a></h1>
        </div>
      </div>
      <div class="content-w3ls">
        <div class="text-center icon">          
          <img :src="logo_img" style="height:120px;"/>

        </div>
        <div class="content-bottom">
          <div class="field-group">
            <span class="fa fa-user" aria-hidden="true"></span>
            <div class="wthree-field">
              <input name="text1" id="text1" type="text" autocomplete='false' v-model="id" placeholder="使用者帳號" required>
            </div>
          </div>
          <div class="field-group">
            <span class="fa fa-lock" aria-hidden="true"></span>
            <div class="wthree-field">
              <input name="password" id="myInput" type="Password" autocomplete='false' v-model="pwd"  placeholder="使用者密碼" required>
            </div>
          </div>
          <div class="wthree-field">
            <button type="submit" class="btn">登入</button>
          </div>
          <ul class="list-login">
            <li class="switch-agileits">
              <label class="switch">
                <input type="checkbox" v-model="isRember">
                  <span class="slider round"></span>
                    Remember ID
              </label>
            </li>
            <li>
              <a href="#" class="text-right"> 忘記密碼 ?</a>
            </li>
            <li class="clearfix"></li>
          </ul>
        </div>
      <ejs-toast ref='toastRef' id='toast_type' :position='position'></ejs-toast>      
      </div>
      <div class="copyright">
        <p>© {{ new Date().getFullYear() }} Design by <a href="http://www.gfnnet.com">Smart Service Co., Ltd.</a></p>
      </div>
      <div class="control-section">
        <ejs-dialog ref="modalPwdDialog" :showCloseIcon='true' :isModal='true' :closeOnEscape='true' :visible='false' header='首次登入請更改密碼' :buttons='dialog_buttons' 
            width='400px'>
            <div formGroup="orderForm">                   
                <div class="form-row">
                    <div class="form-group col-md-12">
                        <ejs-textbox id='txtpwd' floatLabelType="Auto" placeholder="請輸入密碼" type="password" v-model="e_pwd" aria-required="true"></ejs-textbox>   
                    </div> 
                     <div class="form-group col-md-12">
                        <ejs-textbox id='txtpwd2' floatLabelType="Auto" placeholder="再次確認密碼" type="password" v-model="e_pwd2" aria-required="true"></ejs-textbox>    
                    </div>
                </div> 
            </div>                
        </ejs-dialog> 
      </div>
    </section>
  </form>
  </div>  
  
</template>
<script>

  import Vue from "vue";
  import Loading from 'vue-loading-overlay';
  import logoImg from '../../../public/img/avatars/wetrusty-logo-2.png';  
  import backImg from '../../../public/img/avatars/bg.png';

  import { DialogPlugin } from '@syncfusion/ej2-vue-popups';  
  import { ToastComponent } from "@syncfusion/ej2-vue-notifications";
  import { TextBoxPlugin } from '@syncfusion/ej2-vue-inputs';

  Vue.use(Loading);
  Vue.use(DialogPlugin);
  Vue.use(TextBoxPlugin);
  let loader = undefined;

  export default {
    name: 'Login',
    components: {   
      'ejs-toast': ToastComponent,
    },
    data () {
      return {
        isRember: localStorage.getItem('isRember'),
        id: localStorage.getItem('isRember') ? localStorage.getItem('userid') : '',        
        pwd: null, e_pwd: "", e_pwd2: "",
        logo_img : logoImg, back_img : backImg,
        position: { X: 'Right', Y: "Bottom" }, ShowBtn: false,
        dialog_buttons: [{
          click: this.dialog_editOkClick,
          buttonModel: { content: '確認更改密碼', isPrimary: true } 
        }, { 
          click: function() { this.hide(); }, 
          buttonModel: { content: '取消', isPrimary: false}
        }],
      }
    },
    methods: {
      login: function () {  
        this.showLoading();
        this.axios({
            method: 'post',
            baseURL: Vue.prototype.GLOBAL.baseURL,
            url: 'Account/Login',
            headers: {'Content-Type' : 'application/json'},
            data : {
              id: this.id,
              pwd: this.pwd
            }
        })
        .then((response) => {       
          if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); this.hideLoading(); return; } 
          this.hideLoading();
          localStorage.setItem('isRember',  this.isRember);  
          localStorage.setItem('userid',    this.isRember ? this.id : '' );       
          localStorage.setItem('token',     response.data.datas.ticket);                
          localStorage.setItem('name',      response.data.datas.name);
          if (response.data.datas.change_pwd) {
            this.$refs.modalPwdDialog.show();
            return;
          }
          this.$router.push('/')   
        
        })
        .catch((error) => { this.showError(error, true) }

        )               
      },
      dialog_editOkClick: function () {  
        if (this.e_pwd != this.e_pwd2) {  
          this.e_msg = "兩者密碼不相同,請重新輸入"
          return
        }
        this.axios({
            method: 'put',
            baseURL: Vue.prototype.GLOBAL.baseURL,
            url: 'Account/ChangePwd',
            headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
            data : {
              pwd: this.e_pwd
            }
          })
          .then((response) => {             
            if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); this.hideLoading(); return; } 
            this.$refs.modalPwdDialog.hide();          
            this.showMsg(`密碼已修正,請重新登入`);
            this.pwd = ""; this.e_pwd = ""; this.e_pwd2 = "";
          })
          .catch((error) => {this.showError(error, true)}
        )        
      },
      showError: function (error) {     
        this.hideLoading();
        if (error.response.status == 400) {
          for(var key in error.response.data.errors){      
            this.$refs.toastRef.show( { title: '警告!', content: error.response.data.errors[key][0] , cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });           
          }
          return;
        }   
        if (error.response.status == 401) {
          localStorage.removeItem('token'); this.$router.push('/login');
          return;
        }
        this.$refs.toastRef.show( { title: '錯誤!', content: error.response.status, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });
      },
      showMsg: function (msg) {
        this.$refs.toastRef.show( { title: '訊息!', content: msg, cssClass: 'e-toast-info', icon: 'e-info toast-icons' });
      },
      showLoading() {
        loader = this.$loading.show({
            container: this.$refs.loadingContainer,
            canCancel: true, // default false
            onCancel: this.yourCallbackMethod,
            color: 'green',
            loader: 'dots',  // spinner, dots, bars
            width: 164,
            height: 164,
            backgroundColor: 'black',
            opacity: 0.5,
            zIndex: 999,
        });
      },
      hideLoading() {
        loader.hide();
      }
    } 
  }
</script>
<style>  
</style>
<style lang="scss" src="../../scss/login.scss"></style>
<style lang="scss" src="../../scss/base.scss"></style>